import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentLibrarySelector } from '../selectors/LibrarySelector';
import DeprecatedFooter from '../components/deprecated/Footer';

function mapStateToProps(state) {
  const library = currentLibrarySelector(state);
  return {
    footer: state.getIn(['templates', 'footer']),
    appVersion: state.getIn(['app', 'appVersion']),
    cmsEnabled: library.get('cmsEnabled')
  };
}

/** @extends React.Component */
export class FooterContainer extends BcReactComponent {
  render() {
    if (this.props.footer) {
      return <DeprecatedFooter {...this.props} />;
    }

    return null;
  }
}

FooterContainer.propTypes = {
  appVersion: PropTypes.string.isRequired,
  cmsEnabled: PropTypes.bool,
  footer: PropTypes.string
};

export default connect(mapStateToProps)(FooterContainer);
